import React, { useMemo } from "react";
import { NavLink, Outlet } from "react-router-dom";

function formatTabTitle(title: string) {
  if (!title) return "";
  return title
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function CommonContainer({ SUBNAV, children, TITLE }: any) {
  const tabs = useMemo(
    () =>
      (SUBNAV || []).filter(
        (item: any) => item?.PATH && !String(item.PATH).includes(":"),
      ),
    [SUBNAV],
  );

  return (
    <div className="font-inter antialiased text-erp-ink">
      <div className="relative mb-3 overflow-hidden rounded-lg border border-erp-line bg-gradient-to-r from-white via-white to-erp-surface/60 shadow-[0_1px_2px_rgba(11,28,44,0.04)]">
        <div
          aria-hidden
          className="absolute inset-y-0 left-0 w-[3px] bg-gradient-to-b from-erp-gold via-erp-accent to-erp-navy"
        />

        <div className="flex flex-col gap-2 px-3 py-2 pl-3.5 min-[768px]:flex-row min-[768px]:items-center min-[768px]:justify-between">
          <div className="flex min-w-0 items-center gap-2.5">
            {children ? <div className="shrink-0">{children}</div> : null}
            <div className="min-w-0">
              <p className="m-0 text-[10px] font-semibold uppercase tracking-[0.14em] text-erp-muted">
                Workspace
              </p>
              <h1 className="m-0 mt-0.5 truncate text-[15px] font-semibold leading-none tracking-[-0.01em] text-erp-ink">
                {TITLE ? formatTabTitle(TITLE) : "Section"}
              </h1>
            </div>
          </div>

          {tabs.length > 0 ? (
            <nav
              aria-label={`${TITLE || "Section"} navigation`}
              className="flex overflow-x-auto min-[768px]:max-w-[70%]"
            >
              <div className="inline-flex min-w-min gap-0.5 rounded-md border border-erp-line/80 bg-white/80 p-1">
                {tabs.map((item: any, i: number) => (
                  <NavLink
                    key={`${item.PATH}-${i}`}
                    to={item.PATH}
                    className={({ isActive }) =>
                      [
                        "box-border inline-flex h-8 min-h-8 max-h-8 shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 text-[12.5px] font-medium capitalize leading-none tracking-[0.01em] no-underline",
                        isActive
                          ? "bg-[linear-gradient(180deg,#0b1c2c_0%,#123048_55%,#0f2a40_100%)] text-white"
                          : "bg-transparent text-[#5f758a] hover:bg-[#0b1c2c]/8 hover:text-[#0b1c2c]",
                      ].join(" ")
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <span
                          aria-hidden
                          className={[
                            "h-1.5 w-1.5 shrink-0 rounded-full",
                            isActive ? "bg-erp-gold" : "bg-transparent",
                          ].join(" ")}
                        />
                        {formatTabTitle(item.TITLE)}
                      </>
                    )}
                  </NavLink>
                ))}
              </div>
            </nav>
          ) : null}
        </div>
      </div>

      <div className="min-h-0">
        <Outlet />
      </div>
    </div>
  );
}

export default CommonContainer;
